import {h, Component} from 'preact';
import cx from 'classnames';
import ItemLookup from '@components/reorder/ItemLookup';
import PurchaseHistory from 'components/reorder/PurchaseHistory';
import {client} from '@core/GraphQLProvider';
import {Query} from 'react-apollo';
import Provider from 'preact-context-provider';
import {GetPastPurchases} from '@services/OrdersService/query.graphql';
import Spinner from '../../components/common/Spinner';
import isEmptyOrNil from '@util/fn/isEmptyOrNil';

export const classList = {
    page: {
        body: 'md:flex md:space-content md:my-4',
        subheading: 'text-lg md:text-xl font-bold -mt-px py-2 md:py-6 text-center md:text-left border-t border-b border-grey-lighter border-solid md:border-0'
    },
    tabs: {
        tab: 'flex-1 text-lg font-normal -mt-px py-2 text-center border-t border-b border-grey-lighter border-solid hover:bg-grey-darkest hover:text-white',
        activeTab: 'bg-grey-darkest text-white',
        panel: 'hidden md:block',
        activePanel: 'block'
    },
    rule: 'hidden md:block border-b border-grey-lighter border-solid h-px',
    card: {
        gridContainer: 'relative z-0 catalog-item-card-grid grid md:grid-col-3 lg:grid-col-4 xl:grid-col-5',
        root: 'catalog-item-card flex flex-grow hover:z-10 md:h-112 relative border-b border-r border-grey-lighter border-solid md:border-0',
        inner: 'catalog-item-card-inner flex w-full h-full px-4 py-2 md:p-4 flex-row md:flex-col items-center md:items-start md:absolute bg-white border border-white border-solid md:border md:border-white md:hover:border-grey link4',
        thumbnail: 'card-media block w-24 mr-4 md:w-full md:img-ratio-4x3 float-left md:float-none',
        dummyAnchor: 'absolute pin',
        info: 'card-info flex-1 md:w-full',
        title: 'card-title text-base mb-1 md:pt-1 leading-tight',
        optionTitle: 'card-option-title ellipsis text-base pt-1 mb-1 leading-tight hidden md:block',
        subtitle: 'card-subtitle leading-tight',
        sku: 'card-sku leading-tight',
        price: 'card-price text-base font-bold leading-tight',
        addButtonLS: 'relative z-1 button my-2',
        addButtonSS: 'relative z-1 px-4 self-center text-center active:color-brand'
    }
};

const PURCHASE_HISTORY = 'purchase-history';
const ITEM_LOOKUP = 'item-lookup';

const tabClass = (( {activeTab, tab} ) => {
    return activeTabName =>
        tabName =>
            cx( tab, activeTabName === tabName && activeTab )
})( classList.tabs );

const panelClass = (( {activePanel, panel} ) => {
    return activeTabName =>
        tabName =>
            activeTabName === tabName ? activePanel : panel
})( classList.tabs );

class ReorderApp extends Component {

    state = {
        activeTab: 'purchase-history'
    };

    render () {
        const {activeTab} = this.state;
        const toggleTabClass = tabClass( activeTab );

        return (
            <Provider
                client={client}
                activeTab={activeTab}
            >
                <div className="flex-grow">

                    <div className="flex md:hidden">
                        <h2 onClick={() => this.setState( {activeTab: PURCHASE_HISTORY} )}
                            className={toggleTabClass( PURCHASE_HISTORY )}>Purchase History</h2>
                        <h2 onClick={() => this.setState( {activeTab: ITEM_LOOKUP} )}
                            className={toggleTabClass( ITEM_LOOKUP )}>Item Lookup</h2>
                    </div>

                    <ReorderQuery/>
                </div>
            </Provider>
        );
    }
}

const ReorderQuery = ( props, context ) =>
    <Query
        query={GetPastPurchases}
        variables={{
            resultLimit: 64,
            months: 48,
            filterCart: true
        }}>
        {( {data, loading, error} ) => {

            if ( loading ) {
                return (
                    <div className="h-48 flex justify-center items-center">
                        <Spinner className="md:text-xl" message="Getting your past purchases"/>
                    </div>
                );
            }

            const {activeTab} = context;
            const togglePanelClass = panelClass( activeTab );
            const suggestedProducts = (error || isEmptyOrNil( data )) ? [] : data.suggestedProducts;

            return (
                <div>
                    <ItemLookup className={togglePanelClass( ITEM_LOOKUP )} pastPurchases={suggestedProducts}/>
                    <PurchaseHistory className={togglePanelClass( PURCHASE_HISTORY )} list={suggestedProducts}/>
                </div>
            );
        }}
    </Query>;

export default ReorderApp;



